import {
  collection,
  addDoc,
  doc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import { db } from "../firebase";

export const BANNER_PLACEMENTS = [
  { id: "all", label: "All Pages (Global)" },
  { id: "global_top", label: "Top Ribbon (Across Store)" },
  { id: "home_mid", label: "Home Page (Mid Feed)" },
  { id: "shop_top", label: "Shop Page (Above Catalog)" },
  { id: "product_detail", label: "Product Detail Page" },
  { id: "cart_bottom", label: "Shopping Cart Page" },
];

/**
 * Fetches active banners for a specific placement or 'all'.
 */
export async function getActiveBanners(placement = "all") {
  try {
    const bannersRef = collection(db, "banners");
    let q;
    if (placement === "all") {
      q = query(bannersRef, where("active", "==", true));
    } else {
      // Fetch banners specifically for this placement or global 'all'
      q = query(bannersRef, where("active", "==", true));
    }

    const snap = await getDocs(q);
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));

    // Filter by placement if specific placement requested
    const filtered = placement === "all"
      ? list
      : list.filter(b => b.placement === placement || b.placement === "all");

    // Sort by createdAt descending
    return filtered.sort((a, b) => {
      const timeA = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : 0;
      const timeB = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : 0;
      return timeB - timeA;
    });
  } catch (err) {
    console.error("Error loading active banners:", err);
    return [];
  }
}

/**
 * Fetches all banners for Admin portal.
 */
export async function getAllBanners() {
  try {
    const snap = await getDocs(query(collection(db, "banners"), orderBy("createdAt", "desc")));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    // Fallback if index not yet generated
    const snap = await getDocs(collection(db, "banners"));
    const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    return list.sort((a, b) => {
      const timeA = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : 0;
      const timeB = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : 0;
      return timeB - timeA;
    });
  }
}

/**
 * Creates a new banner (Admin).
 */
export async function createBanner(bannerData) {
  return addDoc(collection(db, "banners"), {
    ...bannerData,
    clicks: 0,
    createdAt: serverTimestamp(),
  });
}

/**
 * Updates a banner's details or active status (Admin).
 */
export async function updateBanner(id, data) {
  return updateDoc(doc(db, "banners", id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

/**
 * Deletes a banner (Admin).
 */
export async function deleteBanner(id) {
  return deleteDoc(doc(db, "banners", id));
}

/**
 * Records a click on an ad banner.
 */
export async function recordBannerClick(bannerId) {
  if (!bannerId) return;
  try {
    await updateDoc(doc(db, "banners", bannerId), {
      clicks: increment(1),
    });
  } catch (err) {
    // Non-blocking
    console.warn("Could not increment banner clicks:", err?.message);
  }
}
